import { render, staticRenderFns } from "./filters-form2.vue?vue&type=template&id=13bf7fe8&scoped=true&"
import script from "./filters-form2.vue?vue&type=script&lang=ts&"
export * from "./filters-form2.vue?vue&type=script&lang=ts&"
import style0 from "./filters-form2.vue?vue&type=style&index=0&id=13bf7fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf7fe8",
  null
  
)

export default component.exports